import * as store from "store";
import { Loading } from "../components/loading";
import { Modal } from "../components/modal";
import { Setting } from "../components/setting";
import { $$ } from "../utils/dom";
import {
  IJournalData,
  JOURNAL_DATA,
  JOURNAL_DATA_ALL
} from "./../constants/journal";
import { HttpService } from "./http-service";
import { isDoi } from "./parsers/doi-parser";
import { RichTextService } from "./rich-text-service";

export class DownloadService {
  private $$a: HTMLAnchorElement[];
  private loading: Loading;
  private richTextService: RichTextService;
  private modal: Modal;
  private setting: Setting;
  private referenceCount: number;
  private resolvedReferenceCount: number;
  private rejectedReferenceCount: number;
  private data: IJournalData;
  private http: HttpService;

  constructor() {
    this.setting = Setting.instance;
    this.modal = Modal.instance;
    this.http = new HttpService();
    this.richTextService = RichTextService.instance;
    this.loading = Loading.instance;
  }

  public download() {
    this.referenceCount = this.richTextService.getRefCount();
    this.$$a = $$("#js__output_container a") as HTMLAnchorElement[];
    if (!this.isValidateRef()) {
      return;
    }
    const useFull = this.setting.getOne("js__useFull");
    this.data = useFull ? JOURNAL_DATA_ALL : JOURNAL_DATA;
    this.resolvedReferenceCount = 0;
    this.rejectedReferenceCount = 0;
    const hasDoi = this.hasDoi()
    if (hasDoi) {
      this.modal.show('hasDoi')
        .then(() => this.resolveAll())
    } else {
      this.resolveAll()
    }
  }
  private hasDoi() {
    return this.$$a.some($a => {
      if (!$a.textContent) {
        return false;
      }
      if (isDoi($a.textContent)) {
        return true;
      }
      return false;
    });
  }

  private resolveAll() {
    this.loading.show();
    this.$$a.forEach($a => {
      return this.resolveLink($a);
    });
  }

  private isValidateRef() {
    const fullyCompleted =
      this.$$a.length && this.$$a.every($a => $a.className === "resolved");
    if (this.$$a.length === 0) {
      this.modal.show("notFound");
      return false;
    }
    if (fullyCompleted) {
      this.onDownloadComplete();
      return false;
    }
    return true;
  }

  private resolveLink($a: HTMLAnchorElement) {
    if ($a.className === "resolved" && $a.getAttribute("href") !== "#") {
      this.resolvedReferenceCount += 1;
      return;
    }
    $a.className = "pending";
    const q = $a.textContent as string;
    const abbr = q.toLowerCase().replace(/[^a-z]/g, "");
    const setting = this.setting.get();
    let useSciHub = false;
    if (!isDoi(q)) {
      if (setting) {
        useSciHub = setting[abbr];
      } else {
        if (this.data[abbr]) {
          useSciHub = !this.data[abbr].canAchieve;
        }
      }
    }
    this.resolveReference(q, {
      q,
      pdf: this.setting.getOne("js__pdf"),
      useSciHub
    })
      .then((url: string) => {
        store.set(q, url);
        $a.className = "resolved";
        $a.setAttribute("target", "_blank");
        $a.setAttribute("href", url);
        this.resolvedReferenceCount += 1;
        this.onDownloadComplete();
      })
      .catch(err => {
        $a.className = "rejected";
        this.rejectedReferenceCount += 1;
        this.onDownloadComplete();
      });
  }

  private resolveReference(ref: string, payload: object) {
    const link = store.get(ref);
    if (link) {
      return Promise.resolve(link);
    }
    return new Promise((resolve, reject) => {
      this.http
        .post(payload)
        .then(({ data }) => {
          if (data.status === 0 && data.data[0].status === 0) {
            const url = data.data[0].url;
            resolve(url);
          } else {
            reject("Server Error");
          }
        })
        .catch(err => {
          reject("Server Error");
        });
    });
  }

  private onDownloadComplete() {
    const res = this.resolvedReferenceCount;
    const rej = this.rejectedReferenceCount;
    const all = this.referenceCount;
    if (res + rej !== all) {
      return;
    }
    this.loading.hide();
    setTimeout(async () => {
      if (res === 0) {
        if (rej === 0) {
          this.modal.show("notFound");
        } else {
          this.modal.show("failed");
        }
        return;
      }
      const failed = rej === 0 ? "" : `（${rej}条解析失败）`;
      const confirmText = `即将打开${res}个标签页${failed}，是否继续？（如果浏览器拦截，请允许弹出窗口并再试一次）`;
      const showRetry = rej > 0;
      const willOpen = await this.modal.show("openLinks", {
        showRetry,
        text: confirmText
      });
      if (!willOpen) {
        return;
      }
      if (willOpen === "retry") {
        this.download();
        return;
      }
      const $$resolved = $$(".resolved") as HTMLAnchorElement[];
      $$resolved.forEach(($a, i) => {
        setTimeout(() => {
          window.open($a.href);
        }, i * 100);
      });
    }, 50);
  }
}



// WEBPACK FOOTER //
// ../~/tslint-loader!./scripts/services/download-service.ts